import { MenuItem, TextField } from "@mui/material";
import { PARKING_ACTIVE_STATE_INIT, PARKING_ACTIVE_STATE_PAID } from "../../utils/listitem";
import { useTranslation } from "react-i18next";


const ParkingActiveStateSelect = (props) => {
    const { t } = useTranslation();
    return <TextField {...props} label={t('PAYMENT_STATE')} select>
        <MenuItem value={""}>{t("ALL")}</MenuItem>
        <MenuItem value={PARKING_ACTIVE_STATE_INIT}>{t(PARKING_ACTIVE_STATE_INIT)}</MenuItem>
        <MenuItem value={PARKING_ACTIVE_STATE_PAID}>{t(PARKING_ACTIVE_STATE_PAID)}</MenuItem>
    </TextField>;
}

export default ParkingActiveStateSelect;
